import { gql } from '@apollo/client';

export const GET_GRAPHIC_PACKING_LIST = gql`
    query GraphicList($id: ID!) {
        graphicList(id: $id) {
            id
            title
            status
            start_build_at
            start_event_at
            stands_count
            creator_id
            relCreator {
                id
                name
                surname
            }
            created_at
            updated_at
        }
    }
`;

export const GET_GRAPHIC_PACKING_LISTS_CURSOR = gql`
    query GraphicListsCursor(
        $text: String,
        $where: QueryGraphicListsCursorWhereWhereConditions,
        $orderBy: [QueryGraphicListsCursorOrderByOrderByClause!],
        $first: Int,
        $after: String
    ) {
        graphicListsCursor(
            text: $text,
            where: $where,
            orderBy: $orderBy,
            first: $first,
            after: $after
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
                total
                count
                currentPage
            }
            edges {
                node {
                    id
                    title
                    status
                    start_build_at
                    start_event_at
                    stands_count
                    creator_id
                    relCreator {
                        id
                        name
                        surname
                    }
                    created_at
                    updated_at
                }
                cursor
            }
        }
    }
`;